import { render, staticRenderFns } from "./GoldMembershipTier.vue?vue&type=template&id=70717f9a&"
import script from "./GoldMembershipTier.vue?vue&type=script&lang=ts&"
export * from "./GoldMembershipTier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports